// extracted by mini-css-extract-plugin
export default {"container":"can_container__sCdD0","text":"can_text__iz2cK","icon":"can_icon__7j17S"};